const archivedProjects = {
    '/ease-attendance': {
        label: 'Ease Attendance · 2021–2025',
        title: 'Shut down in 2025.',
        paragraphs: [
            {
                id: 'origin',
                content: (
                    <>
                        Varun and I created Ease Attendance during the <strong>COVID-19 pandemic</strong> after watching
                        our teachers at <strong>Mission San Jose High School</strong> struggle to take attendance in
                        remote classes.
                    </>
                ),
            },
            {
                id: 'thanks',
                content: (
                    <>
                        <strong>Mr. Brucker and Ms. Eugster</strong> became early testers and advocates for the project,
                        and their feedback helped shape it. We are also grateful to <strong>everyone who donated</strong>
                        {' '}and helped keep it running.
                    </>
                ),
            },
            {
                id: 'shutdown',
                content: (
                    <>
                        Ease Attendance automated attendance for Zoom and Webex classes. It eventually became
                        unmaintainable as a small independent service, so we shut it down in 2025.
                    </>
                ),
            },
            {
                id: 'impact',
                content: (
                    <>
                        Over its lifetime, Ease Attendance served <strong>4,459 teachers</strong> and
                        {' '}<strong>121,615 students</strong> across <strong>4,332 classes</strong>, generating
                        {' '}<strong>more than 1.2 million attendance records</strong>.
                    </>
                ),
            },
        ],
        footer: 'Built with Varun Chitturi, Sunny Chadha, and Devan Velji',
        source: 'https://github.com/adityapatel-sudo/ease-attendance',
    },
    '/mycadences': {
        label: 'MyCadences · 2024',
        title: 'No longer public.',
        paragraphs: [
            {
                id: 'closure',
                content: (
                    <>
                        MyCadences turned Spotify listening history into playlists and music insights. Spotify now
                        requires 250,000 monthly active users for extended API access, making a public version
                        unrealistic for an independent project.
                    </>
                ),
            },
        ],
        footer: 'Built with Eric Qian at BoilerMake XI',
        source: 'https://github.com/adityapatel-sudo/spotifyHelper',
    },
};

export default archivedProjects;
